import ArrayPillsInput from './ArrayPillsInput';

export default ArrayPillsInput;
